import { CoinsIcon } from '@phosphor-icons/react'

export const errorTypes = {
  nameOrInternalNameEmpty: 'nameOrInternalNameEmpty',
  nameEmpty: 'nameEmpty',
  internalNameEmpty: 'internalNameEmpty',
  descriptionEmpty: 'descriptionEmpty',
  descriptionTooLong: 'descriptionTooLong',
  regionsEmpty: 'regionsEmpty',
  carrierEmpty: 'carrierEmpty',
  priceEmpty: 'priceEmpty',
  priceOrCurrencyEmpty: 'priceOrCurrencyEmpty',
  locationIdEmpty: 'locationIdEmpty',
  deliveryDaysEmpty: 'deliveryDaysEmpty',
  deliveryDaysLowerEmpty: 'deliveryDaysLowerEmpty',
  deliveryDaysUpperEmpty: 'deliveryDaysUpperEmpty',
  gramsRangeEmpty: 'gramsRangeEmpty',
  gramsRangeLowerEmpty: 'gramsRangeLowerEmpty',
  gramsRangeUpperEmpty: 'gramsRangeUpperEmpty',
  priceRangeEmpty: 'priceRangeEmpty',
  priceRangeLowerEmpty: 'priceRangeLowerEmpty',
  priceRangeUpperEmpty: 'priceRangeUpperEmpty',
  currencyEmpty: 'currencyEmpty',
  invalidRegionForCarrierService: 'invalidRegionForCarrierService',
  invalidLocationForCarrierService: 'invalidLocationForCarrierService',
}

export const shippingMethodDescriptionMaxLength = 150

export const shippingMethodDescriptionMaxStoredLength = 256

export const shippingMethodDescriptionSections = [
  {
    label: 'Costes',
    Icon: CoinsIcon,
    id: 'costs',
  },
]

export const shippingMethodDescriptionVariables = [
  {
    variable: '{{shipping}}',
    label: 'Coste de envío',
    example: 'Envío {{shipping}}, entrega en 3-5 días laborables',
    exampleValue: '10,52 €',
    section: 'costs',
  },
  {
    variable: '{{duties}}',
    label: 'Aranceles',
    example: 'Incluye {{duties}} de aranceles de importación',
    exampleValue: '62,40 €',
    section: 'costs',
  },
  {
    variable: '{{taxes}}',
    label: 'Impuestos',
    example: 'Incluye {{taxes}} de impuestos de importación',
    exampleValue: '43,03 €',
    section: 'costs',
  },
  {
    variable: '{{handling_fees}}',
    label: 'Tasas de tramitación',
    example: 'Incluye {{handling_fees}} de tasas de tramitación aduanera',
    exampleValue: '2,00 €',
    section: 'costs',
  },
  {
    variable: '{{duties_and_taxes}}',
    label: 'Aranceles e impuestos',
    example: 'Incluye {{duties_and_taxes}} de aranceles e impuestos. Sin cargos en la entrega',
    exampleValue: '105,43 €',
    section: 'costs',
  },
  {
    variable: '{{duties_taxes_and_fees}}',
    label: 'Aranceles, impuestos y tasas',
    example: 'Incluye {{duties_taxes_and_fees}} de aranceles, impuestos y tasas de tramitación',
    exampleValue: '107,43 €',
    section: 'costs',
  },
]
